import React, { useState, useEffect } from 'react'
import ContentWrapper from '../layouts/contentWrapper'
import Filter from '../../components/Filter';
import Loading from '../../components/Loading';
import ModalCompany from '../modals/modal-company';
import CompanySettings from '../modals/modal-company-settings';
import Grid from '../../components/Grid';
import api from '../../services/api'
import ShowMessages from './../../components/Exceptions'
import setStatistic from './../../services/apiStatistic'
import {checkPermission} from './../../components/security'
import Swal from 'sweetalert2'

export default function Company() {
    const [loading, setLoading]                            = useState(false)
    const [showModal, setShowModal]                        = useState(false)
    const [showSettings, setShowSettings]                  = useState(false)
    const [isOpenFilter, setIsOpenFilter]                  = useState(false)
    const [reload, setReload]                              = useState(false)
    const [print, setPrint]                                = useState(false)
    const [excel, setExcel]                                = useState(false)
    const [showButtons, setShowButtons]                    = useState(false)
    const [editState, setEditState]                        = useState(false)
    const [gridParams, setGridParams]                      = useState({})
    const [data, setData]                                  = useState({})
    const [filters, setFilters]                            = useState([])

    const [editPermission, setEditPermisson]               = useState(false)
    const getCompany = async() => {
        let _delCheck    = !checkPermission(4,6)
        let _editCheck   = !checkPermission(8,6)
        let _configCheck = !checkPermission(32,6)
        setEditPermisson(_editCheck)
        setGridParams({idcompany        : {text       : "#ID", mask : { name  : 'leftSlice',
                                                                        value : '00000'},
                                           primaryKey  : true},          
                       company          : {text        : "Razão Social" },
                       fantasy          : {text        : "Nome Fantasia",
                                           searchDefault : true},
                       cnpj             : {text        : "CNPJ"},
                       email            : {text        : "Email"},
                       phones           : {text        : "Telefones",
                                           dataType    : "number"},
                       Options          : {text        : "Opções",
                                           className   : "text-center",
                                           order       : false,
                                           filter      : false,
                                           item        : [{type  : "Custom",
                                                           props : {tag            : "button",
                                                                    title          : "Exclusão de empresa",
                                                                    className      : 'btn btn-sm btn-danger',
                                                                    icon           : "fa fa-trash",
                                                                    disabled       : _delCheck,
                                                                    message        : "Deseja realmente excluir a empresa?",
                                                                    indexcallback  : 0}},
                                                          {type  : "Custom",
                                                           props : {tag            : "button",
                                                                    title          : "Editar empresa",
                                                                    className      : 'btn btn-sm btn-warning',
                                                                    icon           : "fa fa-edit",
                                                                    disabled       : _editCheck,
                                                                    indexcallback  : 1}},
                                                          {type  : "Custom",
                                                           props : {tag            : "button",
                                                                    title          : "Espelho do cadastro fiscal",
                                                                    className      : 'btn btn-sm btn-dark padding0',
                                                                    icon           : "fa fa-newspaper",
                                                                    indexcallback  : 2}},
                                                          {type  : "Custom",
                                                           props : {tag            : "button",
                                                                    title          : "Configurações da Empresa",
                                                                    className      : 'btn btn-sm btn-primary padding0',
                                                                    disabled       : _configCheck,
                                                                    icon           : "fa fa-cogs",
                                                                    indexcallback  : 3}}]}
                                             
                 })
    }

    useEffect(() => {
        getCompany()
        setStatistic('maintenance\\company')
    },[])
    
    const handleCloseModal = () => {setShowModal(false)}
    const handleFilter     = () => {setIsOpenFilter(!isOpenFilter)}

    const RemoveCompany = async (id) => {   
        Swal.fire({
            title: 'Confirmação',
            text: "Deseja realmente excluir a empresa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then(async(result) => {
            if (result.isConfirmed) {
                await api.delete('/company/' + id)
                         .then(response => {
                            ShowMessages(response.data)
                            setReload(true)
                        })
                        .catch( error => {
                            ShowMessages(error)
                        })
            }
            
        }) 

    }

    const EditCompany = async(id) => {
        await api.get('/company/' + id)
                 .then(response => {
                    setData(response.data)
                    setEditState(true)
                    setShowModal(true)
                 })
                 .catch( error => {
                    ShowMessages(error)
                 })
    }

    const CardCompany = async(id) => {
        await api.get('/company-card/' + id)
                 .then(response => { 
                        const downloadLink = document.createElement("a");
                        const fileName = "Inscrição Cadastral.pdf";
                        downloadLink.href = "data:application/pdf;base64," + response.data;
                        downloadLink.download = fileName;
                        downloadLink.click();

                        setLoading(false)
                  })
                  .catch( error => { 
                      setLoading(false)
                      ShowMessages(error)
                  })
        
    }

    const SettingsCompany = async(id) => {
        await api.get('/company/' + id)
                 .then(response => {
                        setData(response.data)
                        setShowSettings(true)
                        })
                 .catch( error => {
                    ShowMessages(error)
                 })
    }

    return (    
        <ContentWrapper>
            {loading && (
                <Loading loading={loading}/>
            )}
            <ModalCompany showModal={showModal} handleCloseModal = {handleCloseModal} editState={editState} data={data} handleReload={setReload}/>
            <CompanySettings showModal={showSettings} handleCloseModal = {setShowSettings} data={data} handleReload={setReload}/>
            <div className={`container-lg container-100 ${(loading ? "hidden" : "")}`}>
                <div className="content-heading">
                    <div className="box-maintance-buttons">
                        <div>
                            <button className="btn btn-success" disabled={!checkPermission(2,6)} title="Insere um novo registro" onClick={e => {setEditState(false) 
                                                                                                               setShowModal(true)}}><i className="fa fa-plus"></i></button>
                            <button className="btn btn-primary" title="Atualizar Dados" style={{marginLeft:"3px"}} onClick={e => setReload(true)}><i className="fa fa-redo"></i></button>
                            {showButtons ? 
                                <>
                                    <button className="btn btn-dark" title="Impressão" onClick={e => setPrint(true)} style={{marginLeft:"3px"}}><i className="fa fa-print"></i></button>
                                    <button className="btn btn-info" disabled={!checkPermission(16,6)} title="Exportar para excel" onClick={e => setExcel(true)} style={{marginLeft:"3px"}}><i className="fa fa-file-excel">    </i></button>
                                    <button className="btn btn-secondary" title="Filtros Avançados" style={{marginLeft:"3px"}} onClick={e => handleFilter()}><i className="fa fa-search-plus"></i></button>
                                </>
                            : "" }
                        </div>
                    </div>
                </div>
            </div>
            <div className={`content-box-cart ${(loading ? "hidden" : "")}`}>
                <Filter isOpenFilter={isOpenFilter} filters={gridParams} callback={setFilters} callBackOpenFilter={handleFilter}/>
                <Grid url                 = '/company' 
                      headers             = {gridParams} 
                      loading             = {setLoading} 
                      reload              = {reload}
                      print               = {print}
                      excel               = {excel}
                      filters             = {filters}
                      callbackShowButtons = {setShowButtons}
                      callbackPrint       = {setPrint}
                      callbackReload      = {setReload}
                      callbackExcel       = {setExcel}
                      filename            = "Empresa"
                      callbackCellClick   = {editPermission ? undefined : EditCompany}
                      callbackButtons     = {[RemoveCompany, 
                                              EditCompany,
                                              CardCompany,
                                              SettingsCompany]}
                      />  
               
            </div>                    
        </ContentWrapper>
    )
}